import React from 'react';
import './TermsAndConditions.css';

const RefundCancellationTerms = () => {
    return (
        <div className="ip-terms-container">
            <h1 className="ip-terms-title">Cancellation and Refund Policy</h1>

            <div className="ip-terms-section">
                <h2 className="ip-terms-section-title">1) Cancellation &amp; Refund</h2>
                <ol className="ip-terms-section-content">
                    <li>
                        In the event of a customer missing a session before 12 hours, they can reschedule the counselling only once (career coach or industry expert). No cancellation will be allowed.
                    </li>
                    <li>
                        No cancellation or refund will be permitted after taking the counselling session.
                    </li>
                </ol>
            </div>

            <div className="ip-terms-section">
                <h2 className="ip-terms-section-title">2) Exception</h2>
                <p className="ip-terms-section-content">
                    The Company reserves the right to refund by reviewing the requests via email on a case-by-case basis.
                </p>
            </div>

            <p className="ip-terms-section-content">
                For any further information regarding the cancellation and refund policy, please contact{' '}
                <a href="mailto:Saranraj@idealpursuits.co.in">Saranraj@idealpursuits.co.in</a>.
            </p>
        </div>
    );
};

export default RefundCancellationTerms;
